import {
  DTOCreateForgeAgent,
  DTOCreateForgeAgentResponse,
  DTODeleteForgeAgentResponse,
  DTOUpdateForgeAgent,
  DTOUpdateForgeAgentResponse,
} from "../../dto";
import { RequestExecutor } from "../../transport";

export class ForgeAgentsEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  list(workspaceId: string, projectId: string) {
    return this.requestExecutor.json(
      `/workspaces/${workspaceId}/forge/projects/${projectId}/agents`,
      DTOUpdateForgeAgentResponse,
      {
        method: "GET",
      }
    );
  }

  create(workspaceId: string, projectId: string, body: DTOCreateForgeAgent) {
    return this.requestExecutor.json(
      `/workspaces/${workspaceId}/forge/projects/${projectId}/agents`,
      DTOCreateForgeAgentResponse,
      {
        method: "POST",
        body,
      }
    );
  }

  update(workspaceId: string, projectId: string, id: string, body: DTOUpdateForgeAgent) {
    return this.requestExecutor.json(
      `/workspaces/${workspaceId}/forge/projects/${projectId}/agents/${id}`,
      DTOCreateForgeAgentResponse,
      {
        method: "PUT",
        body,
      }
    );
  }

  delete(workspaceId: string, projectId: string, id: string) {
    return this.requestExecutor.json(
      `/workspaces/${workspaceId}/forge/projects/${projectId}/agents/${id}`,
      DTODeleteForgeAgentResponse,
      {
        method: "DELETE",
      }
    );
  }
}
